var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createStore } from 'zustand/vanilla';
import WordPressAjaxService from '../components/wordpress-ajax-service';
const ProductPageStore = createStore((set, get) => ({
    api: new WordPressAjaxService(window.perlaData.ajax_url, window.perlaData.productPageNonce),
    isLoading: false,
    postId: 0,
    perPage: 5,
    offset: 4,
    hasMore: true,
    comments: '',
    setApi(api) {
        set({ api });
    },
    setPostId: (postId) => set({
        postId,
    }),
    loadComments() {
        set({ isLoading: true });
        fetchReviews()
            .then((data) => {
            set({
                offset: data.offset,
                hasMore: data.has_more,
                comments: data.comments,
            });
        })
            .finally(() => {
            set({ isLoading: false });
        });
    },
    rateReview(commentId, action) {
        return __awaiter(this, void 0, void 0, function* () {
            return rateReview(commentId, action);
        });
    },
}));
function fetchReviews() {
    return __awaiter(this, void 0, void 0, function* () {
        const { api, postId, perPage, offset } = ProductPageStore.getState();
        try {
            const response = yield api.sendRequest('load_reviews', { post_id: postId, offset, per_page: perPage });
            if (response.success) {
                return response.data;
            }
        }
        catch (error) {
            console.error('Request failed:', error);
        }
        return { comments: '', has_more: true, offset };
    });
}
function rateReview(commentId, action) {
    return __awaiter(this, void 0, void 0, function* () {
        const { api } = ProductPageStore.getState();
        try {
            const response = yield api.sendRequest('rate_review', { comment_id: commentId, action_type: action });
            if (response.success) {
                return Object.assign({}, response.data);
            }
        }
        catch (error) {
            console.error('Request failed:', error);
        }
        return { likes: 0, dislikes: 0 };
    });
}
export { ProductPageStore };
